// TODO: Initialize OpenTelemetry SDK here before other imports (ea-context PRIN-011)

import './i18n.js'
import './styles/app.scss'

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/app.js'
import AppProviders from './contexts/appProviders.js'

createRoot(document.getElementById('root') as HTMLDivElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
)
